<div class="language_games home-pg-header__web" [ngClass]=" !isLoggedIn ? 'mobile_view': ''" id="homepage-languages">
    <!-- <div class="hide-below-992 home-lobby__tabs">
        <h2 class="header_lang--title" *ngIf="!promotion">{{'guestHome.who_counting' | translate}}</h2>
        <div *ngIf="promotion">
            <span class="back_promotion" routerLink="{{'/'+ langCode +'/promotions'}}">
                &#x2715;
            </span>
            <span class="header_lang--title header_allPromotions" >
                {{'allpromotionsComp.backtoPromotions' | translate}}
            </span>
        </div>
    </div> -->
    <!--Enable along with PNP banner updates ticket-->
    <!-- <div class="show-below-992 lobby_header--left home-lobby__tabs">
        <app-lobby-tabs [homePage]="isHomePage" [lobbyDetails]="lobbyDetails">
        </app-lobby-tabs>
    </div> -->
    <div class="show-below-992 pills_width" *ngIf="( (isLoggedIn && isHomePage) || promotions ) && windowType=='mobile'">
        <div class="lobby_header--left">
            <app-lobby-tabs [homePage]="isHomePage" [lobbyDetails]="lobbyDetails">
            </app-lobby-tabs>
        </div>
    </div> 
    <!--Desktop-->
    <div class="hide-below-992 lobby_header--left home-lobby__tabs" *ngIf="!promotion  && windowType=='desktop'">
        <app-lobby-tabs [homePage]="isHomePage" [lobbyDetails]="lobbyDetails">
        </app-lobby-tabs>
    </div>
    <div *ngIf="promotion">
        <span class="back_promotion" routerLink="{{'/'+ langCode +'/promotions'}}">
            &#x2715;
        </span>
        <span class="header_lang--title header_allPromotions" >
            {{'allpromotionsComp.backtoPromotions' | translate}}
        </span>
    </div>

    <div class="header_language" *ngIf="(!isLoggedIn && windowType == 'mobile') || ( isHomePage && windowType == 'desktop') || promotion || promotions">
        <!-- Games Search Bar -->
        <!-- <div class="home_search-icon icon icon-search-1" (click)="showSearchBar()"></div> -->
        <div class="home_games--search" id="searchgames">
            <app-slot-games-search></app-slot-games-search>
        </div>
        
        <!-- Language Dropdown -->
        <div class="overlay" *ngIf="viewLang"></div>
        <div *ngIf="!promotion && !allPromotions && !promotions">
            <div class="language-selection-wrap">
                <button #langSelect class="select-lang-box" (click)="viewLang = !viewLang">
                    <span class="lang-country-flag">
                        <img [attr.src]="'/assets/country_flags/'+langCode+'.svg'" />
                    </span>
                    <span class="lang-country-lang">{{langCode | countryName }}</span>
                    <i class="icon icon-dropdown-arrow"></i>
                </button>
                <ul class="select-lang-dropdown" [ngClass]="viewLang ? 'show' : 'hide'">
                    <li [ngClass]="{'active': langCode === lang}" [value]="lang"
                        *ngFor="let lang of mappedLanguageCodes">
                        <a href="{{'/'+lang}}" (click)="listClick($event, lang)">
                            <span class="lang-country-flag">
                                <img [attr.src]="'/assets/country_flags/'+lang+'.svg'" />
                            </span> 
                            <span class="lang-country-text">{{ lang | countryName}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="promotion && !allPromotions">
            <div class="language-selection-wrap">
                <button #langSelect class="select-lang-box" (click)="viewLang = !viewLang">
                    <span class="lang-country-flag">
                        <img [attr.src]="'/assets/country_flags/'+langCode+'.svg'" />
                    </span>
                    <span class="lang-country-lang">{{langCode | countryName }}</span>
                    <i class="icon icon-dropdown-arrow"></i>
                </button>
                <ul class="select-lang-dropdown" [ngClass]="viewLang ? 'show' : 'hide'">
                    <li [ngClass]="{'active': langCode === lang}" [value]="lang"
                        *ngFor="let lang of promotionMappedLanguageCodes">
                        <a href="{{'/'+lang}}" (click)="listClick($event, lang)">
                            <span class="lang-country-flag">
                                <img [attr.src]="'/assets/country_flags/'+lang+'.svg'" />
                            </span> 
                            <span class="lang-country-text">{{ lang | countryName}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="!promotion && !allPromotions && promotions">
            <div class="language-selection-wrap">
                <button #langSelect class="select-lang-box" (click)="viewLang = !viewLang">
                    <span class="lang-country-flag">
                        <img [attr.src]="'/assets/country_flags/'+langCode+'.svg'" />
                    </span>
                    <span class="lang-country-lang">{{langCode | countryName }}</span>
                    <i class="icon icon-dropdown-arrow"></i>
                </button>
                <ul class="select-lang-dropdown" [ngClass]="viewLang ? 'show' : 'hide'">
                    <li [ngClass]="{'active': langCode === lang}" [value]="lang"
                        *ngFor="let lang of allPromotionMappedLanguageCodes">
                        <a href="{{'/'+lang}}" (click)="listClick($event, lang)">
                            <span class="lang-country-flag">
                                <img [attr.src]="'/assets/country_flags/'+lang+'.svg'" />
                            </span> 
                            <span class="lang-country-text">{{ lang | countryName}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<app-search-sticky-bar></app-search-sticky-bar>